export * from "./cfs-template-multi-column-carousel.component";
